export default __webpack_public_path__ + "static/media/Minicard_Qs.f353d973.svg";